import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Cyber insurance solutions for businesses facing dark web risks" 
          className="hero-image" 
        />
        <p className="eyebrow">Darknet Insurance</p>
        <h1>Protect Your Business from Dark Web Risks</h1>
        <p className="lede">
          Tailored cyber insurance solutions to safeguard against emerging threats.
        </p>
      </header>

      <section className="cards">
        <article>
          <h2>Comprehensive Cyber Insurance for Modern Risks</h2>
          <p>
            At Darknetinsurance, we specialize in providing businesses with effective cyber insurance solutions designed to tackle the unique threats posed by the dark web. From risk assessments to claims support, we ensure your business stays protected.
          </p>
          <a href="/get-quote" className="cta-button">Get a Free Quote</a>
        </article>
      </section>
    </div>
  );
}

export default App;